module.exports = __webpack_public_path__ + "static/media/home6.f31153aa.jpg";